import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorMessage } from 'utilities/error-message';
// Utilities
import HttpClient from 'utilities/HttpClient';
import { mediaMessages } from './mediaMessages';
import { appActions } from 'store/app/appSlice';

const _http:HttpClient = new HttpClient();
const _url:string = '/media';

// Get media
export const getMedia = createAsyncThunk(
  'media/Get media',
  async (params:any = {}, { rejectWithValue }) => {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key: string) => {
      if (params[key]) searchParams.append(key, params[key]);
    });

    const response:Response = await _http.get(`${_url}?${searchParams}`);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
)

// Upload media
export const uploadMedia = createAsyncThunk(
  'media/Upload media',
  async (data:any, { rejectWithValue, fulfillWithValue }) => {
    const { blob, title, type, quizId, format } = data;
    const contentType = blob.type;
    const response:Response = await _http.post(`${_url}/uploads`, { contentType });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    const { token, url } = await response.json();

    // Signed response
    const signedResponse:Response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': contentType
      },
      body: blob
    });
    if ( !signedResponse.ok ) return rejectWithValue((await signedResponse.json()) as any);

    const nextData:any = { contentType, token, type };
    if (title) nextData['title'] = title;
    if (quizId) nextData['quizId'] = quizId;
    if (format) nextData['format'] = format;

    const uploadResponse:Response = await _http.post(_url, nextData);
    if ( !uploadResponse.ok ) return rejectWithValue((await response.json()) as any);
    return uploadResponse.json();
  }
);

// Save AI generated image as media. Generated images already sit in the uploads folder,
// so the media record is created straight from the upload token taken from the image URL.
export const saveGeneratedMedia = createAsyncThunk(
  'media/Save generated media',
  async (data:{ url:string, format:string, quizId?:string }, { rejectWithValue }) => {
    const { url, format, quizId } = data;
    const token = new URL(url).pathname.split('/').pop();

    const nextData:any = { contentType: 'image/png', token, type: 'image', format };
    if (quizId) nextData['quizId'] = quizId;

    const response:Response = await _http.post(_url, nextData);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);

// Delete media
export const deleteMedia = createAsyncThunk(
  'media/Delete media',
  async (mediaId:string, { rejectWithValue, fulfillWithValue, dispatch }) => {
    const response:Response = await _http.delete(`${_url}/${mediaId}`);
    if ( !response.ok ){
      const body = await response.json();
      const message = body.message || `${errorMessage('deleting')} API error: ${body.status}`
      return rejectWithValue({ message });
    }
    dispatch(appActions.createNotification({ message: mediaMessages.delete }));
    return fulfillWithValue(mediaId);
  }
);

// Clone media
export const cloneMedia = createAsyncThunk(
  'media/Clone media',
  async (data:{ownerIds:string[], mediaIds:string[]}, { rejectWithValue, dispatch }) => {
    const response:Response = await _http.post(`${_url}/clone`, data);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    dispatch(appActions.createNotification({ message: mediaMessages.clone }));
  }
);
